import { Fragment } from 'react';
import { Box, Link, Text } from '@stitch-fix/mode-react';
import { isNonEmptyString } from '../../utils/helpers';

interface DescriptionLink {
  href: string;
  text: string;
}

export interface HeaderProps {
  description?: string;
  descriptionLinks?: DescriptionLink[];
  title: string;
}

const parseDescription = (
  description: string,
  descriptionLinks: DescriptionLink[],
) => {
  // {} within the description indicates a link goes here
  // splitting the description at the {} and replacing it with the corresponding descriptionLink
  // returns a new string with inline links
  return description.split(/{\d}/g).map((text, index) => {
    const descriptionLink = descriptionLinks[index];

    // return any remaining text after the last link
    if (!descriptionLink) {
      return text;
    }

    return (
      <Fragment key={text}>
        {text}
        <Link href={descriptionLink.href}>{descriptionLink.text}</Link>
      </Fragment>
    );
  });
};

export const Header = ({
  description,
  descriptionLinks,
  title,
}: HeaderProps) => {
  const shouldRender = isNonEmptyString(title) || isNonEmptyString(description);

  if (!shouldRender) {
    return null;
  }

  return (
    <Box px={1.5}>
      <Text align={{ sm: 'left', md: 'center' }} setting="title-large" mb={0.7}>
        {title}
      </Text>
      {description && (
        <Text
          align={{ sm: 'left', md: 'center' }}
          setting="body-small"
          mx={{ md: 'auto' }}
          style={{
            // add max width to help with legibility and prevent text from
            // running on
            maxWidth: '750px',
          }}
          spacingBottom
        >
          {descriptionLinks
            ? parseDescription(description, descriptionLinks)
            : description}
        </Text>
      )}
    </Box>
  );
};
